import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class HomeTeamCardComponent extends Component {
  @service store;

  @tracked _team = this.args.team ?? null;

  get team() {
    return this._team;
  }

  get memberCount() {
    return this._team?.activeMembers?.length ?? 0;
  }

  @action
  loadTeam() {
    if (!this.args.teamId) return;
    this.store
      .findRecord('team', this.args.teamId)
      .then((team) => {
        this._team = team;
      })
      .catch((error) => {
        console.error('Error loading team:', error);
      });
  }
}
